export const TransactionApplication = {
  ALLPAID: "APD",
  ALLPAID_VT: "APD VT",
  CYG_VT: "CYG VT",
};

// GPS rows written before the APD labels: "Allpaid", and briefly "AllPaid VT".
const LEGACY_UUID_APPLICATIONS = ["allpaid", "allpaid vt"];

export const showsUuid = (application) => {
  if (typeof application !== "string") {
    return false;
  }
  const value = application.toLowerCase();
  return (
    LEGACY_UUID_APPLICATIONS.includes(value) ||
    Object.values(TransactionApplication).some(
      (stored) => stored.toLowerCase() === value
    )
  );
};
